import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { removeMenuCategoryFromMenu } from '../../../../../../../../crud/menu_api/menus';

interface RemoveMenuCategoryFromMenuModalProps {
  showDeleteModal: boolean;
  setShowDeleteModal: (show: boolean) => void;
  selectedCategories: string[]; // Por ejemplo, el/los nombre(s) de la(s) categoría(s)
  selectedCategoryId: number | null;
  selectedmenuId: number | null;
  onMenuCategoryRemoved?: (menuId: number, categoryId: number) => void;
}

const RemoveCategoryFromMenu: React.FC<RemoveMenuCategoryFromMenuModalProps> = ({
  showDeleteModal,
  setShowDeleteModal,
  selectedCategories,
  selectedCategoryId,
  selectedmenuId,
  onMenuCategoryRemoved,
}) => {
  const handleDeleteCategories = async () => {
    try {
      if (selectedmenuId === null || selectedCategoryId === null) {
        toast.error("No se ha seleccionado un menú o categoría válida.");
        return;
      }
      await removeMenuCategoryFromMenu(selectedmenuId, selectedCategoryId);
      toast.success(`Categoría ${selectedCategories.join(', ')} eliminada del menú exitosamente`);
      setShowDeleteModal(false);
      if (onMenuCategoryRemoved && selectedmenuId !== null && selectedCategoryId !== null) {
        onMenuCategoryRemoved(selectedmenuId, selectedCategoryId);
      }
    } catch (error) {
      console.error('Error eliminando la categoría:', error);
      toast.error(`Error eliminando la categoría ${selectedCategories.join(', ')} del menú`);
    }
  };

  return (
    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Confirmar eliminación</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        ¿Estás seguro de que quieres remover esta categoría del menú?
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </Button>
          <Button className="form-button-create" onClick={handleDeleteCategories}>
            Eliminar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveCategoryFromMenu;
